export const interfaces = {
  imports: {
    table: {
      title: "Liste des interfaces d'import",
      title_modal_import: "Ajout interface d'export",
      message_modal_confirm: 'Le flux existe déjà. Voulez-vous modifier les éléments de ce flux ',
      columns: {
        state: 'Etat',
        code: 'Code',
        name: 'Nom',
        type: 'Type',
        flow: 'Flux',
        format: 'Format',
        import_type: "Type d'import",
        entity_selection: 'Sélection entité',
        updated_date: 'Date de modification',
      },
    },
    fiche: {
      title: {
        edit_import: "Fiche de l'interface d'import {{code}}",
        new_import: "Création d'une nouvelle interface d'import",
        entity_list: 'Liste des entités',
        general: 'Général',
      },
      buttons: {
        back: 'Annuler',
        save: 'Valider',
        add: 'Ajouter',
        close: 'Fermer',
      },
      modal: {
        title: "Sélection d'entités",
      },
      champ_titles: {
        code: 'Code',
        description: 'Description',
        type: 'Type',
        flow: 'Flux',
        import_type: 'Type import',
        state: 'Etat',
        file_format: 'Format de fichier',
        encryption: 'Chiffrement',
        entity_selection: 'Sélection entité',
        no_encryption: 'Aucun chiffrement',
        email_rules: "Emails d'erreur",
        duplicate: 'Contrôle de doublons',
      },
      columns: {
        state: 'Etat',
        code: 'Code',
        name: 'Name',
      },
    },
    detail: {
      table: {
        title: "Liste des enregistrements de l'interface",
        buttons: {
          back: 'Retour',
        },
        columns: {
          database_field: 'Champ database',
          registration: 'Enregistrement',
          heading: 'Rubrique',
          default_value: 'Valeur par défaut',
          method: 'Méthode',
          update_timestamp: 'Date de modification',
        },
      },
      fiche: {
        title: {
          edit: "Fiche de l'enregistrement",
          new: "Création d'un nouvel enregistrement",
        },
        champ_titles: {
          database_field: 'Champ database',
          heading: 'Rubrique',
          method: 'Méthode',
          correspondence: 'Correspondance',
          default_value: 'Valeur par défaut',
          order: 'Ordre',
        },
        buttons: {
          back: 'Annuler',
          save: 'Valider',
        },
      },
    },
  },
  exports: {
    table: {
      title: "Liste des interfaces d'export",
      title_modal_import: "Ajout interface d'export",
      message_modal_confirm: ' L’interface export existe déjà. Voulez-vous modifier les éléments de cette interface',
      columns: {
        code: 'Code',
        name: 'Nom',
        format: 'Format',
        updated_date: 'Date de modification',
      },
    },
    fiche: {
      title: {
        edit_export: "Fiche de l'interface d'export {{code}}",
        new_export: "Création d'une nouvelle interface d'export",
      },
      buttons: {
        back: 'Annuler',
        save: 'Valider',
      },
      champ_titles: {
        code: 'Code',
        description: 'Description',
        type: 'Type',
        file_format: 'Format de fichier',
        formatting: 'Mise en forme',
      },
    },
    detail: {
      table: {
        title: "Liste des enregistrements de l'interface",
        buttons: {
          back: 'Retour',
        },
        columns: {
          database_field: 'Champ database',
          registration: 'Enregistrement',
          heading: 'Rubrique',
          default_value: 'Valeur par défaut',
          method: 'Méthode',
          update_timestamp: 'Date de modification',
          comment: 'Commentaire'
        },
      },
      fiche: {
        title: {
          edit: "Fiche de l'enregistrement",
          new: "Création d'un nouvel enregistrement",
        },
        champ_titles: {
          database_field: 'Champ database',
          heading: 'Rubrique',
          method: 'Méthode',
          correspondence: 'Correspondance',
          default_value: 'Valeur par défaut',
          order: 'Ordre',
        },
        buttons: {
          back: 'Annuler',
          save: 'Valider',
        },
      },
    },
    detailIsPdf: {
      table: {
        title: "Création d'un nouvel enregistrement",
        buttons: {
          back: 'Retour',
        },
        columns: {
          champs: 'Champ',
          heading: 'Rubrique',
          database: 'Database',
          chp_dtb1: 'Champ 1',
          chp_dtb2: 'Champ 2',
          chp_dtb3: 'Champ 3',
          chp_dtb4: 'Champ 4',
          chp_dtb5: 'Champ 5',
          chp_dtb6: 'Champ 6',
          chp_dtb7: 'Champ 7',
          chp_dtb8: 'Champ 8',
          method: 'Méthode',
          mask: 'Masque',
          mise_en_page: 'Surcharge de la mise en page',
          polise: 'Police',
          taille: 'Taille',
          alignement: 'Alignement',
          gras: 'Gras',
          soulign: 'Souligné'
        },
      },
    },
  },
  formats: {
    table: {
      title: 'Liste des formats de fichiers',
      columns: {
        code: 'Code',
        name: 'Nom',
        type: 'Type',
        updated_date: 'Date de modification',
        length: 'Longueur enr.',
        separator: 'Séparateur',
        comment: 'Commentaire',
      },
      buttons: {
        import: 'Importer'
      },
      modal: {
        title: "Importation d'un format",
        champ_titles: {
          upload: 'Upload'
        }
      }
    },
    fiche: {
      title: {
        edit_format: 'Fiche du format {{code}}',
        new_format: "Création d'un nouveau format",
      },
      buttons: {
        back: 'Annuler',
        save: 'Valider',
      },
      champ_titles: {
        code: 'Code',
        name: 'Nom',
        type: 'Type',
        length: 'Longueur enr.',
        separator: 'Séparateur',
        header: 'Avec Entête',
        multi: 'Multi-Chèques par page',
        offset: 'Offset',
      },
    },
    detail: {
      table: {
        title: 'Liste des enregistrements du format',
        buttons: {
          back: 'Retour',
        },
        columns: {
          order: 'Ordre',
          code: 'Code',
          type: 'Type',
          update_timestamp: 'Date de modification',
          length: 'Longueur enr.',
          separator: 'Séparateur',
        },
      },
      fiche: {
        title: {
          edit: "Fiche de l'enregistrement {{code}}",
          new: "Création d'un nouvel enregistrement",
        },
        champ_titles: {
          code: 'Code',
          type: 'Type',
          order: 'Ordre',
        },
        buttons: {
          back: 'Annuler',
          save: 'Valider',
        },
      },
    },
    heading: {
      table: {
        title: 'Liste des champs',
        buttons: {
          back: 'Retour',
        },
        columns: {
          order: 'Ordre',
          label: 'Libellé',
          type: 'Type',
          position: 'Position',
          length: 'Longueur',
          update_timestamp: 'Date de modification',
        },
      },
      fiche: {
        title: {
          edit: "Fiche de l'enregistrement",
          new: "Création d'un nouvel enregistrement",
          propriety: 'Propriétés',
          visu_export_comptable:
            'Affichage pour visualisation Export Comptable',
        },
        champ_titles: {
          label: 'Libellé',
          type: 'Type',
          order: 'Ordre',
          mask: 'Masque',
          separator: 'Séparateur',
          line_if_item: 'Ligne si rubrique',
          position: 'Position {{cord}}',
          length: 'Longueur',
          height: 'Hauteur',
          thickness: 'Épaisseur',
          visible: 'Visible Affichage',
          field_length: 'Longueur Affichage',
        },
        buttons: {
          back: 'Annuler',
          save: 'Valider',
        },
      },
    },
  },
  import_rule: {
    table: {
      header: {
        title: "Liste des règles d'import",
      },
      modal: {
        remove: {
          title: "Voulez-vous vraiment supprimer cette règle d'import",
        },
      },
      columns: {
        state: 'Etat',
        connector: 'Connecteur',
        partner: 'Partenaire',
        import_interface: "Interface d'import",
        format: 'Format',
        condition: 'Condition',
        extension: 'Extension',
        directory: 'Repertoire',
      },
    },
    fiche: {
      title: {
        create_import_rule: "Création de nouvelles règle d'import",
        edit_import_rule: "Modification des règle d'import",
        conditions: 'Conditions',
      },
      champ_titles: {
        state: 'Etat',
        connector: 'Connecteur ERP',
        import_interface: "Interface d'import",
        type: 'Type',
        treatment_after_import: 'Traitement après import',
        file_name: 'Nom du fichier',
        directory: 'Répertoire',
        extension: 'Extension du fichier',
      },
      buttons: {
        back: 'Annuler',
        save: 'Valider',
      },
    },
  },
  export_rule: {
    table: {
      header: {
        title: "Liste des règles d'export",
      },
      modal: {
        remove: {
          title: "Voulez-vous vraiment supprimer cette règle d'export",
        },
      },
      columns: {
        state: 'Etat',
        rule_code: 'Code Règle',
        rule_name: 'Nom Règle',
        method: 'Méthode',
        periodicity: 'Périodicité',
        launch_time: 'Heure Lancement',
        last_launch: 'Dernier Lancement',
        file_name: 'Nom Fichier',
        update_timestamp: 'Date de modification',
        extension: 'Extension',
        directory: 'Repertoire',
      },
    },
    fiche: {
      title: {
        create_export_rule: "Création de nouvelles règle d'Export",
        edit_export_rule: "Modification des règle d'export {{code}}",
        conditions: 'Conditions',
        request_content: 'Contenu Requête',
      },
      champ_titles: {
        state: 'Etat',
        rule_code: 'Code  Règle',
        rule_name: 'Nom Règle',
        method: 'Méthode',
        periodicity: 'Périodicité',
        end_point: 'End Point',
        type: 'Type',
        file_name: 'Nom du fichier',
        directory: 'Répertoire',
        extension: 'Extension du fichier',
      },
      buttons: {
        back: 'Annuler',
        save: 'Valider',
      },
    },
  },
  flux: {
    table: {
      title: 'Liste des flux',
      title_modal_confirm: "Ajout des flux",
      list_missing_champ: "Champs manquants : ",
      headerTitle: {
        code: 'Code',
        nom: 'Nom',
        type: 'Type',
        support: 'Support',
        process_signature: 'Process de signature',
        confidential: 'Confidentialité',
        interface_export: "Interface d'export",
        date: 'Date de modification',
      },
    },
    fiche: {
      title: "Création d'un nouveau flux",
      code: 'Code',
      nom: 'Nom',
      type: 'Type',
      support: 'Support',
      creation_title_fiche: "Creation d'un nouveau flux",
      edit_tile_fiche: 'Fiche du flux {{code}}',
      flow_code_placeholder: "Code du Flux",
      flow_nom_placeholder: "Nom du Flux",
      sous_type: "Sous-type",
      methodeAttribution: "Méthode d'attribution des valideurs",
      typeDoc_compte: 'Type de document compte',
      typeDoc_societe: 'Type de document société',
      caracteristique: {
        title: 'Caractéristiques',
        flux_confidentiel: 'Flux confidentiel',
        process_signature: 'Process signature',
        interface_export: "Interface d'export par défaut",
        methode_attribution: "Méthode d'attribution des signataires",
        controle_mandat: 'Contrôle Mandat',
        control_date: 'Gestion de date',
        autorisation: "Autorisation Split du lot",
        type_doc: "Type de document"

      },
      masque_saisie: {
        title: 'Masques saisie',
        coordonne_bank: 'Coordonnées bancaires',
        bank_intermediaire: 'Banque intermédiaire',
        type_dest: 'Type destinataire',
        saisie_liste: 'Saisie par liste',
      },
      tresorerie: {
        title: 'Trésorerie',
        prevision_emmet: 'Prévision Emetteur',
        prevision_tiers: 'Prévision Tiers',
        type_prev: 'Type de prévision',
        nature_tiers: 'Nature tiers',
        nature_emmet: 'Nature émetteur',
        categ_tiers: 'Catégorie tiers',
        categ_emmet: 'Catégorie émetteur',
        exonere: 'Exonéré',
        title_code_cature: 'Sélection du code nature',
        title_categorie: 'Sélection du catégorie',

        add: 'Ajouter',
        annuler: 'Annuler',
      },
      pays_emmet: {
        title: 'Pays émetteurs autorisés',
      },
      pays_dest: {
        title: 'Pays destinataires autorisés',
      },
      authorized_currencies: {
        title: 'Devises autorisées',
      },
      authorized_bank: {
        title: 'Banques autorisées',
      },
      interface_export: {
        title: "Interfaces d'export spécifiques par banque",
        title_Modal: "Sélection de l'interface d'export par banque",
        add: 'Ajouter',
        annuler: 'Annuler',
        bank: 'Banque',
        interf_exp: "Interface d'export",
        headerTable: {
          code: 'Code',
          interface_export: "Interface d'export",
        },
      },
      mask: {
        title_mask_remise: 'Masques remises',
        title_mask_operation: 'Masques opérations',
        title_mask_compta: "Masques comptes comptables",

        headerTable: {
          name: 'Nom du champ',
          interface_export: "Interface d'export",
          type_champ: 'Type de champ',
          libelle: 'Libellé',
          visible: 'Visible',
          obligatoire: 'Obligatoire',
          edit: 'Modifiable en saisie',
          taille_saisie: 'Taille de saisie',
        },
        title_Modal: 'Masque de saisie',
        add: 'Ajouter',
        annuler: 'Annuler',
        name_champ: 'Nom du champ',
        maskTitle: 'Masque',
      },
      modalSetting: {
        title: 'Paramétrage',
        seuil: 'Seuil de génération',
        seuilPlaceholder:
          "Nombre d'opération au delà duquel la génération sera effectuée à l'import du fichier",
        mailBox: 'MailBox',
        flux_post: 'Flux Post Génération',
        demate_connector: "Connecteur Demat",
        demate_connector2: "Connecteur Demat 2",
        accepts_operation_zero: "Autoriser montant zéro en saisie",
        control_adress_tiers: "Contrôle Adresse Tiers en saisie",
        add_mvt: "Ajout mouvements dans CC",
        mail_box_edit_date: 'Autorisation modification date',
        CheminDateModif: 'Chemin modification date'
      },
    },
  },
};
